<template>
	<div class="solution-summary pb-2">
		<b-card no-body v-if="listProduct.length > 0">
			<b-card-header header-bg-variant="primary" header-class="p-2 text-white">
				Other Cases
			</b-card-header>
			<b-card-body class="px-4 py-2">
				<b-row class="mb-3 pt-2" v-for="(product, index) in listProduct" :key="index">
					<b-col cols="12" md="9">
						<b-row>
							<b-col cols="12" md="4">
								<b-form-group label="Product">
									<b-form-input v-model="product.product_detail.prod_oth_type" type="text" required
										disabled></b-form-input>
								</b-form-group>
							</b-col>
							<b-col cols="12" md="4">
								<b-form-group label="Product Detail">
									<b-form-input v-model="product.product_detail.prod_oth_detail" type="text" required
										disabled></b-form-input>
								</b-form-group>
							</b-col>
							<b-col cols="12" md="4">
								<b-form-group label="Product Value (RM)">
									<b-form-input v-model="product.product_detail.prod_oth_value" type="text" required
										disabled></b-form-input>
								</b-form-group>
							</b-col>
							<b-col cols="12" md="4">
								<b-form-group label="Loan Agreement (RM)">
									<b-form-input v-model="product.product_detail.prod_oth_agreement_fees" type="text" required
										disabled></b-form-input>
								</b-form-group>
							</b-col>
							<b-col cols="12" md="6">
								<b-form-group label="Payment Mode">
									<b-form-input v-model="product.product_detail.prod_oth_pay_mode" type="text" required
										disabled></b-form-input>
								</b-form-group>
							</b-col>
						</b-row>
					</b-col>
					<b-col cols="12" class="mx-auto mt-1 pb-1">
						<b-row>
							<b-col cols="12">
								<div class="d-flex justify-content-end align-items-center">
									<div>
										<el-button class="bg-info py-2 text-white" @click="generatePerformaInfoice(product)"
											:loading="is_loading.case && is_loading.value === product.prod_id">
											<small class="font-weight-bold text-white"
												v-if="_gHlp.isEmpty(product.proforma_invoice_id)">GENERATE PERFORMA INVOICE</small>
											<small class="font-weight-bold text-white" v-else>VIEW PERFORMA INVOICE</small>
										</el-button>
										<el-button class="bg-success py-2 text-white" @click="convertProductToCaseHandler(product.prod_id)"
											:loading="is_loading.case && is_loading.value === product.prod_id"><small
												class="font-weight-bold text-white">CONVERT TO CASE</small>
										</el-button>
										<el-button class="bg-danger py-2 text-white" @click="removeProductHandler(product)"
											:loading="is_loading.case && is_loading.value === product.prod_id"><small
												class="font-weight-bold text-white">REMOVE</small>
										</el-button>
									</div>
								</div>
							</b-col>
						</b-row>
					</b-col>
				</b-row>
			</b-card-body>
		</b-card>
		<div class="text-center mt-5" v-else>No draft found.</div>
		<DrawerProFormaInvoiceForm ref="drawer_proforma_invoice_form" @close="getRelatedInvoice()" />
	</div>
</template>
<script>
import { Image, Button, Select, Option } from 'element-ui'
import CurrencyInput from '@/components/CurrencyInput'
import { mapState, mapActions } from 'pinia'
import { useProductStore } from '@/stores/productStore'
import { useNotificationStore } from '@/stores/notificationStore'
import { useMessagingStore } from '@/stores/messagingStore'
import { useBillingStore } from '@/stores/billingStore'
import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin.js'
import helperFunctionMixin from '@/assets/js/helperFunctionMixin.js'
import DrawerProFormaInvoiceForm from '@/views/Sales/ProFormaInvoices/OffCanvasProFormaInvoices/ProFormaInvoiceForm'
import _ from 'lodash'

export default {
	mixins: [notifyFunctionMixin, helperFunctionMixin],
	components: {
		CurrencyInput,
		DrawerProFormaInvoiceForm,
		[Image.name]: Image,
		[Button.name]: Button,
		[Select.name]: Select,
		[Option.name]: Option,
	},
	data() {
		return {
			listInvoice: [],
			listProduct: [],
			is_loading: {
				case: false,
				value: ''
			},
		}
	},
	watch: {
		listInvoice: {
			handler(newVal) {
				this.injectProducts();
			},
			immediate: true
		},
		mortgage_draft_products: {
			handler(newVal) {
				this.injectProducts();
			},
			immediate: true
		},
		is_active: {
			handler(newVal) {
				if (newVal) {
					this.getRelatedInvoice();
				}
			},
			immediate: true
		},
	},

	computed: {
		...mapState(useProductStore, ['other_draft_products']),
	},
	methods: {
		...mapActions(useBillingStore, ['getInvoices']),
		...mapActions(useProductStore, ['removeProduct', 'convertProductToCase']),
		...mapActions(useNotificationStore, ['fetchEmailTemplate']),
		...mapActions(useMessagingStore, ['sendEmail']),
		resetIsLoading() {
			this.is_loading.case = false
			this.is_loading.value = null
		},
		async convertProductToCaseHandler(id) {
			this.is_loading.case = true
			this.is_loading.value = id
			try {
				await this.convertProductToCase(id, 'other')
				await this.sendCaseApprovalEmail(id)
				this.resetIsLoading()
				this.notifySuccess('<b>Case Successfully Created </b> - Pending Approval.')
			} catch (e) {
				this.errorFunction(e)
				this.resetIsLoading()
				return
			}
		},
		async sendCaseApprovalEmail(id) {
			try {
				const emailTemplate = await this.fetchEmailTemplate('CREATE_CASE_APPROVAL');
				if (emailTemplate && emailTemplate.is_active == 1) {

					const recipients = emailTemplate.notif_temp_receiver.split(',').map(email => email.trim());

					// Prepare the email data
					const emailData = {
						to: recipients,
						subject: emailTemplate.notif_temp_title,
						body: emailTemplate.notif_temp_message
							.replace('{case_id}', id) // Replace {case_id} with product ID
					};

					await this.sendEmail(emailData);
					this.notifySuccess('Email sent successfully.');
				}
			}
			catch (error) {
				console.error('Failed to send email:', error);
				this.errorFunction(error);
			}
		},
		async removeProductHandler(product) {
			this.is_loading.case = true
			this.is_loading.value = product.prod_id
			try {
				await this.removeProduct(product)
				this.notifySuccess('<b>Draft </b> - Successfully Removed.')
				this.resetIsLoading()
			} catch (e) {
				this.resetIsLoading()
				this.errorFunction(null, e)
			}
		},

		async generatePerformaInfoice(product) {
			const inv = this.listInvoice.find((i) => { return i.inv_id === product.proforma_invoice_id })
			if (!_gHlp.isEmpty(inv)) {
				this.$refs.drawer_proforma_invoice_form.show(inv)
			} else {
				const newProformaInv = {
					inv_user_id: product.prod_customer_id,
					inv_user_type: 'customer',
					inv_user_name: product.prod_customer_name,
					inv_custom_identity: '#' + product.prod_id + '_product',
					inv_stm_id: null, //if set will check existing
					inv_scrb_id: null, //if set will check existing
					inv_pckg_id: null, //if set will check existing
					inv_title: null,
					inv_description: null,
					inv_ref_no: 'INV_PROFORMA_' + product.prod_id + '_PRODUCT',
					inv_issued_date: null,
					inv_status: 'DRAFT', //DRAFT,ISSUED,PAID,CANCELED
					inv_remark: null,
					inv_application_code: _gAuth.appCode(),
					inv_corporate_id: _gAuth.activeCorporateId(),
					inv_items: [
						{
							itm_tittle: 'Agreement Fee',
							itm_description: '',
							itm_qty: 1,
							itm_amount: _gHlp.getValue(product, 'product_detail.prod_oth_agreement_fees', 0),
							itm_total: _gHlp.getValue(product, 'product_detail.prod_oth_agreement_fees', 0),
						}
					],
				}
				this.$refs.drawer_proforma_invoice_form.show(newProformaInv)
			}

		},
		injectProducts() {
			const listProduct = _.clone(this.other_draft_products)
			listProduct.forEach(item => {
				const inv = this.listInvoice.find((i) => { return i.inv_custom_identity === '#' + item.prod_id + "_product" })
				if (!_gHlp.isEmpty(inv)) {
					item['proforma_invoice_id'] = inv.inv_id
				} else {
					item['proforma_invoice_id'] = null
				}
			});
			this.listProduct = listProduct;
		},
		getRelatedInvoice() {
			if (_gHlp.isEmpty(this.other_draft_products)) return;
			const identifiers = this.other_draft_products.map((item) => { return "#" + item.prod_id + "_product" });
			this.getInvoices({
				pagination: { limit: 100 },
				search: {
					inv_custom_identity: identifiers.join(','),
					inv_type: "PROFORMA",
				}
			}).then((resp) => {
				this.listInvoice = _gHlp.getValue(resp, 'content', [])
			})
		}
	}
}
</script>